import type { Route } from "./+types/navigation.layout";

import { useState } from "react";
import { Outlet } from "react-router";

import { getUserCredits } from "~/features/home/queries";
import { CreditRechargeDialog } from "~/features/payments/components/credit-recharge-dialog";
import { getPaymentConfig } from "~/features/payments/lib/packages.server";

import Footer from "../components/footer";
import { logger } from "../lib/logger.server";
import { NavigationBar } from "../components/navigation-bar";
import makeServerClient from "../lib/supa-client.server";

export async function loader({ request }: Route.LoaderArgs) {
  const [client] = makeServerClient(request);

  // Get user data
  const {
    data: { user },
  } = await client.auth.getUser();

  // Get credits if user is authenticated
  let credits = 0;
  if (user) {
    try {
      credits = await getUserCredits(client, user.id);
    } catch (error) {
      logger.error("Failed to fetch user credits", {
        feature: "core",
        operation: "navigation_loader",
        metadata: { error, userId: user.id },
      });
    }
  }

  // Build payment config for authenticated users (with geo-detection)
  const paymentConfig = user ? getPaymentConfig(request, user) : null;

  return {
    user,
    credits,
    paymentConfig,
  };
}

export default function NavigationLayout({ loaderData }: Route.ComponentProps) {
  const { user, credits, paymentConfig } = loaderData;
  const [showRechargeDialog, setShowRechargeDialog] = useState(false);

  return (
    <div className="flex min-h-screen flex-col bg-[#F3F3F1] text-[#111111] selection:bg-black selection:text-white">
      <NavigationBar
        name={
          user?.user_metadata?.full_name ||
          user?.user_metadata?.name ||
          user?.user_metadata?.nickname ||
          undefined
        }
        avatarUrl={user?.user_metadata?.avatar_url ?? null}
        credits={credits}
        loading={false}
        onRechargeClick={user ? () => setShowRechargeDialog(true) : undefined}
      />
      <Outlet />
      <Footer />

      {/* Credit Recharge Dialog */}
      {user && paymentConfig && (
        <CreditRechargeDialog
          open={showRechargeDialog}
          onOpenChange={setShowRechargeDialog}
          config={paymentConfig}
          currentCredits={credits}
        />
      )}
    </div>
  );
}
